import React from "react";
import ReactExport from "react-export-excel";
import Button from '@material-ui/core/Button';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class Download extends React.Component {
    render() {
        return (
            <ExcelFile element={<Button variant="text" style={{color: 'white', fontWeight: 'bold', fontSize: "1em", backgroundColor: '#082430'}}>Exporter les membres</Button>}>
                <ExcelSheet data={this.props.data}  name='Member'>
                    <ExcelColumn label="Id" value="Id"/>
                    <ExcelColumn label="Gender" value="Gender"/>
                    <ExcelColumn label="Langue de contact" value="ContactLanguage"/>
                    <ExcelColumn label="Nom" value="LastName"/>
                    <ExcelColumn label="Prénom" value="FirstName"/>
                    <ExcelColumn label="Email" value="Email"/>
                    <ExcelColumn label="Anniversaire" value="Date"/>
                    <ExcelColumn label="Société" value="Society"/>
                    <ExcelColumn label="Date Inscription" value="AccountCreatedAt"/>
                    <ExcelColumn label="Renouvellement" value="SubscriptionBegin"/>
                    <ExcelColumn label="Fin adhésion" value="SubscriptionEnd"/>
                    <ExcelColumn label="Nombre de participation" value="NumberSubscribeEvent"/>
                    <ExcelColumn label="Ville" value="CityFacturation"/>
                    <ExcelColumn label="Rue" value="StreetFacturation"/>
                    <ExcelColumn label="Code postal" value="ZipCodeFacturation"/>
                    <ExcelColumn label="Téléphone" value="TelPrivate"/>
                    <ExcelColumn label="Type d'inscription" value="RegistrationType"/>
                    <ExcelColumn label="Parrain" value="Parrain"/>
                    <ExcelColumn label="Région" value="Region"/>
                    <ExcelColumn label="Commentaire" value="CommentaryAdmin"/>
                    <ExcelColumn label="Gratuit" value="FreeStatus"/>
                    <ExcelColumn label="Cotisation" value="Cotisation"/>
                    <ExcelColumn label="Source" value="Source"/>
                </ExcelSheet>
            </ExcelFile>
        );
    }
}

export default Download
